import Vue from 'vue'
import Router from 'vue-router'

import home from '@/page/home/home.vue'

import PersonalCenter from '@/page/personalCenter/personalCenter'
import seniorSearch from '@/page/seniorSearch/seniorSearch.vue'
import channelList from '@/page/channelList/channelList.vue'
import collectionCom from '@/page/personalCenter/user/collection'



Vue.use(Router)

export default new Router({
  // base: '/', // 基础路径
  mode: 'history',
  routes: [{
      path: '/',
      name: 'home',
      component: home,
      meta: {
        title: "首页"
      }
    },
    {
      path: '/microauthorization',
      name: 'microauthorization',
      component: () => {
        return import('@/page/home/microauthorization')
      },
      meta: {
        title: "果实微授权"
      }
    },
    {
      path: '/Applyjoin',
      name: 'Applyjoin',
      component: () => {
        return import('@/page/home/Applyjoin')
      },
      meta: {
        title: "企业加入"
      }
    },
    {
      path: '/informationFlow',
      name: 'informationFlow',
      component: () => {
        return import('@/page/home/informationFlow')
      },
      meta: {
        title: "果实信息流"
      }
    },
    {
      path: "/searchResult",
      name: "searchResult",
      component: () => {
        return import('@/page/searchResult/searchResult')
      },
      meta: {
        title: "搜索结果页"
      }
    },
    {
      path: "/seniorSearch",
      name: "seniorSearch",
      component: () => {
        return import('@/page/seniorSearch/seniorSearch')
      },
      meta: {
        title: "高级搜索页"
      }
    },
    {
      path: "/channelList",
      name: "channelList",
      component: () => {
        return import('@/page/channelList/channelList')
      },
      meta: {
        title: "频道列表页"
      }
    },
    {
      path: "/articledetails",
      name: "articledetails",
      component: () => {
        return import('@/page/article_details/article_details')
      },
      meta: {
        title: "文章详情页"
      }
    },
    {
      path: '/personalCenter',
      name: 'personalCenter',
      component: () => {
        return import('@/page/personalCenter/personalCenter')
      },
      redirect: {
        name: 'userAccount'
      },
      meta: {
        title: "个人中心"
      },
      children: [{
          path: '/personalCenter/account',
          name: 'userAccount',
          component: () => {
            return import('@/page/personalCenter/user/account')
          }
        },
        // {
        //     path: '/personalCenter/order',
        //     name: 'userOrder',
        //     component: () => { return import('@/page/personalCenter/user/order') }
        // },
        {
          path: '/personalCenter/collection',
          name: 'userCollection',
          component: () => {
            return import('@/page/personalCenter/user/collection')
          }
        },
        {
          path: '/personalCenter/flow',
          name: 'accreditFlow',
          component: () => {
            return import('@/page/personalCenter/accredit/flow')
          }
        },
        {
            path: '/personalCenter/article',
            name: 'accreditArticle',
            component: () => { return import('@/page/personalCenter/accredit/article') }
        },
        {
          path: '/personalCenter/authorizedbody',
          name: 'authorizedbody',
          component: () => { return import('@/page/personalCenter/accredit/authorizedbody') }
      },
        {
          path: '/personalCenter/package',
          name: 'accreditPackage',
          component: () => {
            return import('@/page/personalCenter/accredit/package')
          }
        },
        {
          path: '/personalCenter/apiControl',
          name: 'accreditApiControl',
          component: () => {
            return import('@/page/personalCenter/accredit/apiControl')
          }
        },
        {
          path: '/personalCenter/members',//企业成员
          name: 'enterpriseMembers',
          component: () => {
            return import('@/page/personalCenter/enterprise/members')
          }
        },
        {
          path: '/personalCenter/subaccountownership',//当前子账号拥有的
          name: 'enterpriseSubaccountownership',
          component: () => {
            return import('@/page/personalCenter/enterprise/subaccountownership')
          }
        },
        {
          path: '/personalCenter/datas',//企业资料
          name: 'enterpriseInformation',
          component: () => {
            return import('@/page/personalCenter/enterprise/datas')
          }
        }
      ]
    },
    {
      path: '/other',
      name: 'other',
      component: () => {
        return import('@/page/other/other')
      },
      redirect: {
        name: 'aboutUs'
      },
      meta: {
        title: "其他"
      },
      children: [
        {
          path: '/other/aboutUs',
          name: 'aboutUs',
          component: () => {
            return import('@/page/other/childs/aboutUs')
          }
        },
        {
          path: '/other/userAgreement',
          name: 'userAgreement',
          component: () => {
            return import('@/page/other/childs/userAgreement')
          }
        },
        {
          path: '/other/privacyProtection',
          name: 'privacyProtection',
          component: () => {
            return import('@/page/other/childs/privacyProtection')
          }
        },
        {
          path: '/other/contact',
          name: 'contact',
          component: () => {
            return import('@/page/other/childs/contact')
          }
        },
        {
          path: '/other/termsService',
          name: 'termsService',
          component: () => {
            return import('@/page/other/childs/termsService')
          }
        },
        {
          path: '/other/licenseAgreement',
          name: 'licenseAgreement',
          component: () => {
            return import('@/page/other/childs/licenseAgreement')
          }
        },
        {
          path: '/other/licensingLimitations',
          name: 'licensingLimitations',
          component: () => {
            return import('@/page/other/childs/licensingLimitations')
          }
        }
        // licenseAgreement.vue
      ]
    },
    {
      path: '/normalQuestion',
      name: 'normalQuestion',
      component: () => {
        return import('@/page/normalQuestion/normalQuestion')
      },
      redirect: {
        name: 'accreditQues'
      },
      meta: {
        title: "问题"
      },
      children: [
        {
          path: '/normalQuestion/accreditQues',
          name: 'accreditQues',
          component: () => {
            return import('@/page/normalQuestion/childs/accreditQues')
          }
        },
        {
          path: '/normalQuestion/payQues',
          name: 'payQues',
          component: () => {
            return import('@/page/normalQuestion/childs/payQues')
          }
        },
        {
          path: '/normalQuestion/accountQues',
          name: 'accountQues',
          component: () => {
            return import('@/page/normalQuestion/childs/accountQues')
          }
        },
        {
          path: '/normalQuestion/moreQues',
          name: 'moreQues',
          component: () => {
            return import('@/page/normalQuestion/childs/moreQues')
          }
        }
      ]
    },
    {
      path: '/apiReview',
      name: 'apiReview',
      component: () => {
        return import('@/page/apiReview/apiReview')
      },
      meta: {
        title: "登录"
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => {
        return import('@/page/login/login')
      },
      meta: {
        title: "登录"
      }
    },
    {
      path: '/',
      redirect: '/'
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// 解决vue中的NavigationDuplicated报错
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js